import { FileIcon } from 'react-file-icon';
import './fileTypeIcon.css';
import { CustomizeStyle } from './customizeStyle';
import classNames from 'classnames';

const FileTypeIcon: React.FC<{ extension: string; className?: string; [key: string]: any }> = ({
  extension,
  className,
  ...props
}) => {
  return (
    <div className={classNames('icon', className)} {...props}>
      <FileIcon extension={extension} {...CustomizeStyle[extension]} />
    </div>
  );
};

export default FileTypeIcon;
